import Dialog from '../toolkit/dialog';

const getMessage = (e: any) => {
  if (e.response) {
    if (e.response.data) {
      if (e.response.data.message) {
        return e.response.data.message;
      }
      return JSON.stringify(e.response.data);
    }
  }
  return e.message;
}

const errorDialog = (e: any) => {
  const dialog = new Dialog({
    title: (e.response && e.message) ? e.message : 'Unexpected Error',
    titleFontFamily: 'Google Sans',
    message: getMessage(e).toString(),
    size: 'small',
  });
  dialog.show();
};

export default errorDialog;
